import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { Accordion, Icon, Menu, Dropdown, Sidebar } from 'semantic-ui-react';
import shortid from 'short-id';
import { menuOptions } from '../../containers/menuOptions';
import domains from '../../containers/Domains';

const { featureFlags } = domains || {};
const { useNewNavUi } = featureFlags || {};

class MenuComponent extends Component {
  state = { activeIndex: -1, activeOption: 'Dashboard', activeItem: null };

  componentWillUnmount() {
    const { toggleNavMenu } = this.props;
    if (toggleNavMenu) {
      toggleNavMenu(false);
    }
  }

  handleAccordion = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  };

  activateOption = (optionName) => {
    this.setState({ activeOption: optionName });
  };

  showSection = (section) => {
    const denied = section.filter((option) =>
      option.deniedGroups.find(
        (deniedGroup) => deniedGroup === this.props.group
      )
    );
    return denied.length < section.length;
  };

  handleItemClick = (e, { name }) => {
    this.setState({ activeItem: name }, () => {
      if (name === 'Home') {
        this.setState({ showMenu: false });
      }
    });
  };

  renderMenuItems = () => {
    const { activeItem } = this.state;
    const { toggleNavMenu, group } = this.props;
    const menuKeys = Object.keys(menuOptions);
    const nonEmptyKeys = menuKeys.filter(
      (key) =>
        menuOptions[key].filter((option) => option.deniedGroups.includes(group))
          .length !== menuOptions[key].length
    );

    return nonEmptyKeys.map((key) => (
      <Dropdown
        key={`${key}-dropdown`}
        item
        text={key}
        active={`${activeItem === key}`}
        onClick={this.handleItemClick}
        direction="right"
        pointing="left"
      >
        <Dropdown.Menu direction="right" pointing="right">
          {menuOptions[key].map((option) => {
            const { deniedGroups, name, url } = option;
            const denied = deniedGroups.includes(group);
            if (denied) {
              return null;
            }
            return (
              <Dropdown.Item
                key={`${name}-item`}
                as={NavLink}
                to={url}
                content={name}
                onClick={() => toggleNavMenu(false)}
              />
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    ));
  };

  render() {
    const { showMenu, group, toggleNavMenu } = this.props;
    const { activeOption, activeIndex } = this.state;
    if (group) {
      if (useNewNavUi) {
        return (
          <Sidebar
            id="app-sidebar-content"
            as={Menu}
            direction="left"
            animation="overlay"
            icon="labeled"
            onHide={() => toggleNavMenu(false)}
            inverted
            vertical
            visible={!!showMenu}
          >
            <Menu.Item
              id="nav-home-button"
              as={NavLink}
              to="/"
              content="Home"
              onClick={() => toggleNavMenu(false)}
            />
            {this.renderMenuItems()}
          </Sidebar>
        );
      }
      return (
        <Menu secondary vertical fluid className="sidebar-container">
          <Menu.Item
            as={NavLink}
            to="/"
            content="Dashboard"
            active={activeOption === 'Dashboard'}
            onClick={() => this.activateOption('Dashboard')}
          />
          <Accordion fluid>
            {Object.keys(menuOptions).map((k, index) => {
              const showSection = this.showSection(menuOptions[k]);
              return showSection ? (
                <div key={shortid.generate()}>
                  <Accordion.Title
                    key={shortid.generate()}
                    index={index}
                    active={activeIndex === index}
                    onClick={this.handleAccordion}
                  >
                    <Icon name="dropdown" /> {k}
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex === index}>
                    {menuOptions[k].map((option) => {
                      const denied = option.deniedGroups.find(
                        (deniedGroup) => deniedGroup === group
                      );
                      if (!denied) {
                        return (
                          <Menu.Item
                            key={shortid.generate()}
                            as={NavLink}
                            active={activeOption === option.name}
                            to={option.url}
                            content={option.name}
                            onClick={() => this.activateOption(option.name)}
                          />
                        );
                      }
                      return null;
                    })}
                  </Accordion.Content>
                </div>
              ) : null;
            })}
          </Accordion>
        </Menu>
      );
    }
    return null;
  }
}

export default MenuComponent;



// WEBPACK FOOTER //
// ./src/components/common/MenuComponent.js